module.exports = __webpack_public_path__ + "media/a4.475ba456.wav";